import React, { useState } from "react";
import UploadCostModal from "./upload.cost.modal";
import styled from "styled-components";
import OutlinedButton from "../../../../../app/components/buttons/outlined";

export default function UploadCost({ studyId, scheduleId }) {
  const [fileUploadOpen, setFileUploadOpen] = useState(false);

  const handleFileUploadClose = () => {
    setFileUploadOpen(false);
    // Remove the page refresh here
  };

  const handleFileUploadContinue = () => {
    setFileUploadOpen(false);
    window.location.reload(); // Refresh the page only when "Continue" is clicked
  };

  return (
    <Container>
      <OutlinedButton onClick={() => setFileUploadOpen(true)}>
        UPLOAD COUNTRY COSTS
      </OutlinedButton>
      {fileUploadOpen && (
        <UploadCostModal
          open={fileUploadOpen}
          onClose={handleFileUploadClose}
          onContinue={handleFileUploadContinue}
          studyId={studyId}
          scheduleId={scheduleId}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;
